import React from "react";
import { Form, FloatingLabel, InputGroup, Row } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { LoginUIProps } from "./Login.types.tsx";

import { ForgotLabel, TitleLabel, SubHeaderLabel, HelpLabel } from "../Labels.tsx";
import { ActionButton, ShowPasswordButton } from "../Buttons.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

const LoginFormUI: React.FC<LoginUIProps> = ({
  formData,
  validated,
  showPassword,
  handleChange,
  handleSubmit,
  handleShowPassword,
}) => {
  const { t } = useTranslation();
  const { loadingComponent, setCurrentView, isLoading } = useLoginContext();

  if (isLoading) return loadingComponent;

  return (
    <Row style={{ maxWidth: 400 }} className="mx-auto">
      <TitleLabel>{t("login.title")}</TitleLabel>
      <SubHeaderLabel>{t("login.subtitle")}</SubHeaderLabel>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <FloatingLabel controlId="floatingEmail" label={t("login.emailLabel")} className="mb-3">
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder=""
          />
          <Form.Control.Feedback type="invalid">{t("login.requiredField")}</Form.Control.Feedback>
        </FloatingLabel>

        <InputGroup>
          <FloatingLabel
            controlId="floatingPassword"
            label={t("login.passwordLabel")}
            className="mb-3"
          >
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
              placeholder=""
            />
            <Form.Control.Feedback type="invalid">{t("login.requiredField")}</Form.Control.Feedback>
          </FloatingLabel>

          <ShowPasswordButton type="button" onClick={handleShowPassword}>
            {showPassword ? <EyeSlash /> : <Eye />}
          </ShowPasswordButton>
        </InputGroup>

        <ForgotLabel onClick={() => setCurrentView("forgot")}>
          {t("login.forgotPassword")}
        </ForgotLabel>

        <ActionButton type="submit">{t("login.loginButton")}</ActionButton>

        <HelpLabel onClick={() => setCurrentView("register")}>
          {t("login.noAccount")} <b>{t("login.signUp")}</b>
        </HelpLabel>

        <HelpLabel onClick={() => setCurrentView("terms")}>
          {t("login.termsText")} <b>{t("login.termsLink")}</b>
        </HelpLabel>
      </Form>
    </Row>
  );
};

export default LoginFormUI;
